import { filter, set, update } from 'lodash';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import { useTheme } from '@mui/material/styles';
import {
    Table,
    Stack,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    TableContainer,
    TablePagination,
    Dialog,
    DialogTitle,
    DialogContent,
    Divider,
    TextField,
    DialogActions,
    Container,
    Autocomplete,
    FormControl,

    RadioGroup,
    FormControlLabel,
    Box,
    Radio
} from '@mui/material';

// redux
import { useDispatch } from 'src/redux/store';

// components
import { UserListHead } from 'src/components/_dashboard/user/list';
import Label from 'src/components/Label';
import Scrollbar from 'src/components/Scrollbar';
import { useSnackbar } from 'notistack';
import useAuth from 'src/hooks/useAuth';

import { TableBorder } from 'src/components/table';
import Iconify from 'src/components/Iconify';
import { HeaderPageComponentConfig } from 'src/components/_dashboard/configuracoes';
import WebhooksMoreMenu from 'src/components/_dashboard/configuracoes/WebhooksMoreMenu';

// actions
import actionCriarWebhook from 'src/actions/clientes/actionCriarWebhook';
import actionListaWebhooks from 'src/actions/clientes/actionListaWebhooks';

// utils
import { fDate, fDateTime } from 'src/utils/formatTime';
import { getTransformEventsWebhook, soNumeros } from 'src/utils/functions';


// zui
import { Button } from 'src/@/components/ui/button';
import ModalAddMake from './Modals/ModalAddMake';
import TableMakeCredentials from './components/TableMakeCredentials';
import v2_actionCredenciais from 'src/actions/v2/cliente/v2_actionCredenciais';
import v2_actionCriarCredenciais from 'src/actions/v2/cliente/v2_actionCriarCredenciais';
import v2_actionEditarCredenciais from 'src/actions/v2/cliente/v2_actionEditarCredenciais';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import v2_actionDeletarCredencias from 'src/actions/v2/cliente/v2_actionDeletarCredencias';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'nome', label: 'Nome', alignRight: false },
    { id: 'setor', label: 'Data Criação', alignRight: false },
    { id: 'status', label: 'Status', alignRight: false },
    { id: 'Email', label: 'Método', alignRight: false },
    { id: 'Acoes', label: 'Ações', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        return filter(array, (_user) => _user.nomeFantasia.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
}

export default function Make() {
    const { logout, user } = useAuth();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('nome');
    const [filterName, setFilterName] = useState('');
    const [openWebhook, setOpenWebook] = useState(false);
    const [nome, setNome] = useState('');
    const [url, setUrl] = useState('');
    const [eventos, setEventos] = useState([]);

    const [isEdit, setIsEdit] = useState(false);
    const [id, setId] = useState(null);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);

    const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);

    async function getList() {
        try {
            let querys = `?source=make`
            const response = await v2_actionCredenciais(user.clienteId, querys);
            setList(response.data.data)
        } catch (error) {
            console.log('error', error)
        }
    }

    async function handleCreate() {
        try {
            let data = {
                scope: {
                    source: "make",
                    createdBy: user.id,
                    keys: {
                        name: nome,
                        url: url
                    }
                }
            }
            const response = await v2_actionCriarCredenciais(user.clienteId, data);
            if (response.status === 200) {
                enqueueSnackbar('Webhook criado com sucesso', { variant: 'success' });
                setOpenWebook(false)
                getList();
                setNome('')
                setUrl('')
            }

        } catch (error) {
            console.log('error', error)
        }
    }

    async function handleEdit() {
        try {
            let data = {
                scope: {
                    keys: {
                        name: nome,
                        url: url
                    }
                }
            }
            await v2_actionEditarCredenciais(id, data);
            getList();
            setNome('');
            setUrl('');
            setIsEdit(false);
            setId(null);
            setOpenWebook(false);
            enqueueSnackbar('Status alterado com sucesso', { variant: 'success' });
        } catch (error) {
            console.log('error', error)
        }
    }

    async function handleChangeStatus(id, value) {
        try {
            let data = {
                scope: {
                    status: value,
                    updateAt: new Date()
                }
            }
            await v2_actionEditarCredenciais(id, data);
            getList();

        } catch (error) {
            console.log('error', error)
        }
    }

    async function handleDeletarTag() {
        try {
            await v2_actionDeletarCredencias(id);
            await getList();
            setId(null);
            setOpenModalConfirmacao(false);

        } catch (error) {

        }

    }

    const events = [
        "whatsapp.payload_message",
        "whatsapp.pesquisa_concluida",
        "whatsapp.after_resposta_pesquisa"
    ]

    useEffect(() => {
        getList()
    }, []);



    const filteredUsers = applySortFilter(list, getComparator(order, orderBy), filterName);


    return (
        <Box>

            <Container sx={{ mt: 4 }} maxWidth="lg">
                <HeaderPageComponentConfig
                    backAction={() => navigate('/dashboard/configuracoes/integracoes')}
                    titulo="Make"
                    descricao={'Envie eventos para integrar com a plataforma make'}
                    actions={<Button onClick={() => setOpenWebook(true)}>Criar</Button>}
                />


                <ModalConfimacao
                    open={openModalConfirmacao}
                    onClose={() => {
                        setOpenModalConfirmacao(false);
                    }}
                    onConfirm={handleDeletarTag}
                    loadingFinalizar={loading}
                    mensagem={'Deseja mesmo excluir?'}
                />


                <ModalAddMake
                    isEdit={isEdit}
                    openWebhook={openWebhook}
                    setOpenWebhook={setOpenWebook}
                    nome={nome}
                    setNome={setNome}
                    url={url}
                    loading={loading}
                    setUrl={setUrl}
                    eventos={eventos}
                    setEventos={setEventos}
                    events={events}
                    getTransformEventsWebhook={getTransformEventsWebhook}
                    onEdit={handleEdit}
                    onCreate={handleCreate}
                    onClose={() => {
                        setOpenWebook(!openWebhook);
                        setNome('');
                        setUrl('');
                        setIsEdit(false);
                        setId(null);
                    }}
                />

                <div className="mt-8">

                    <TableMakeCredentials
                        data={filteredUsers}
                        onDelete={(row) => {
                            setId(row._id);
                            setOpenModalConfirmacao(true);
                        }}
                        onEdit={(row) => {
                            setId(row._id)
                            setIsEdit(true)
                            setNome(row.keys.name)
                            setUrl(row.keys.url)
                            setOpenWebook(true)
                        }}
                        changeStatus={(row, value) => handleChangeStatus(row._id, value)}

                    />

                </div>
            </Container>

        </Box>
    );
}
